<template>
  <BookingDetail />
</template>

<script>
import BookingDetail from '../../booking/BookingDetail'
export default {
  name: 'BookingDetailView',
  components: { BookingDetail },
}
</script>
